<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="!protocolos || !protocolos.length">
    Não foram encontrados arquivos de protocolo com os filtros informados.
  </div>

  <div *ngIf="protocolos?.length">
    <bn-paginacao [total]="atributosPaginacao.count"
    [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
    [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-id-protocolo" scope="col" *ngIf="!cnpjAgente">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'siglaAgente'"
                    [nomeAtributoExibicao]="'Agente financeiro'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-id-protocolo" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'identificadorProtocoloNegocio'"
                    [nomeAtributoExibicao]="'ID protocolo'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th id="col-data-envio" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataEnvio'" [nomeAtributoExibicao]="'Dt. envio'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-usu-envio" scope="col" *ngIf="cnpjAgente">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'usuarioEnvio'" [nomeAtributoExibicao]="'Usu. envio'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-status" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'statusConsultaProtocolo'"
                  [nomeAtributoExibicao]="'Status'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th id="col-tipo-protocolo" scope="col" *ngIf="exibirComboTipoArquivo">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'tipoConsultaProtocolo'"
                  [nomeAtributoExibicao]="'Tipo Protocolo'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th scope="col" class="text-end">
                  Arquivo envio
              </th>
              <th scope="col" class="text-end">
                  Arquivo resposta
              </th>


              <th></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let protocolo of protocolosPaginados">
              <td class="font-monospace" *ngIf="!cnpjAgente">{{ protocolo.siglaAgente }}</td>
              <td class="font-monospace">{{ protocolo.identificadorProtocoloNegocio}}</td>
              <td>{{ protocolo.dataEnvio | date: 'dd/MM/yyyy HH:mm'}}</td>
              <td *ngIf="cnpjAgente">{{ protocolo.usuarioEnvio}}</td>
              <td>{{ obterLabelStatusProtocolo(protocolo.statusConsultaProtocolo) }}</td>
              <td *ngIf="exibirComboTipoArquivo">{{ obterTipoProtocolo(protocolo.statusConsultaProtocolo) }}</td>
              <td class="text-end">
                  <a href="javascript:void(0)" (click)="downloadArquivoEnvio(protocolo.identificadorProtocoloNegocio)">
                    <span class="font-monospace fw--bold"> {{ protocolo.tamanhoConteudoEnvio | fileSize }} </span>
                    <i class="fa fa-download">
                    </i>
                  </a>
              </td>
              <td class="text-end">
                <span *ngIf="protocolo.tamanhoConteudoResposta; else conteudoRespostaNaoDisponivel">
                  <a href="javascript:void(0)" (click)="downloadArquivoResposta(protocolo.identificadorProtocoloNegocio)">
                      <span class="font-monospace fw--bold"> {{ protocolo.tamanhoConteudoResposta | fileSize }} </span>
                      <i class="fa fa-download"></i>
                  </a>
                  <span  class="ms-1" *ngIf="protocolo.conteudoRespostaContemMensagemAlerta">
                    <span> </span><i class="fas fa-exclamation-triangle color-orange" ngbTooltip="Existem avisos no arquivo de resposta."></i>
                  </span>
                </span>
                  <ng-template #conteudoRespostaNaoDisponivel>
                    <span class="font-monospace">Não disponível</span>
                  </ng-template>
              </td>

              <td>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>


